// =============================================================================
// validatePassword.js � Shared password complexity validator (ISO 27001 A.5.17)
// Path: Frontend/src/utils/validatePassword.js
// =============================================================================

export const PASSWORD_RULES = [
  { label: 'At least 12 characters',            test: p => p.length >= 12 },
  { label: 'One uppercase letter (A-Z)',         test: p => /[A-Z]/.test(p) },
  { label: 'One lowercase letter (a-z)',         test: p => /[a-z]/.test(p) },
  { label: 'One number (0-9)',                   test: p => /\d/.test(p) },
  { label: 'One special character (!@#$...)',    test: p => /[!@#$%^&*(),.?":{}|<>]/.test(p) },
  { label: 'Not one of your last 10 passwords', test: () => true },
];

export function validatePassword(pw) {
  return PASSWORD_RULES.every(r => r.test(pw));
}

export function PolicyChecker({ password }) {
  return (
    <ul className="space-y-1 mt-2">
      {PASSWORD_RULES.map(r => {
        const passed = r.test(password);
        return (
          <li key={r.label} className={`flex items-center gap-2 text-xs ${passed ? 'text-green-600' : 'text-gray-400'}`}>
            <span>{passed ? '?' : '?'}</span>
            {r.label}
          </li>
        );
      })}
    </ul>
  );
}
